<template>
  <v-app class='app'>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  mounted() {
    document.oncontextmenu = () => false;
    this.updateZendeskVisibility();
  },

  watch: {
    $route: {
      handler() {
        window.scrollTo(0, 0);
        this.updateZendeskVisibility();
      },
      immediate: true, // ページロード時にも実行
    },
  },

  methods: {
    updateZendeskVisibility() {
      if (this.$route.path === '/' || this.$route.path === '/store' || this.$route.path.startsWith('/store/page/')) {
        document.body.classList.add('show-zendesk');
      } else {
        document.body.classList.remove('show-zendesk');
      }
    },
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>
.v-application--wrap {
  min-height: auto!important;
}
</style>

<style lang="scss">
body.menu-open {
  overflow: hidden !important;
}
html, body {
  font-family: $notoSans;
  // background-image: url('/img/pc_back.jpg');
  background-attachment: fixed;
  background-position: center;
  background-size: auto 120%;

  @media screen and  (max-width: $tabletWidth) {
    background-image: none;
    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      // background-image: url('/img/sp_back.jpg');
      background-size: 100% auto;
      z-index: -1;
    }
  }
}
body {
  @media screen and  (max-width: $tabletWidth) {
    overflow-x: clip;
  }
}
.v-application {
  font-family: $notoSans!important;
  background: none!important;
}
// Zendesk チャットの位置を調整

/* 🔹 Zendesk チャットをデフォルトで非表示 */
iframe[title="メッセージングウィンドウを開くボタン"],
#launcher {
  display: none !important;
}

div[aria-label^="GTCHAX's Aiのメッセージ"] {
  display: none !important;
}

/* 🔹 トップページ (/) のみ Zendesk を表示 */
body.show-zendesk iframe[title="メッセージングウィンドウを開くボタン"],
body.show-zendesk #launcher {
  display: block !important;
  bottom: 85px !important;
}

@media screen and (max-width: $tabletWidth) {
  body.show-zendesk iframe[title="メッセージングウィンドウを開くボタン"],
  body.show-zendesk #launcher {
    bottom: 60px !important;
  }
}
</style>
